import React, {Component} from 'react';
import axios from "axios";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import './ResetPasswordForm.css';
import 'react-notifications/lib/notifications.css';

const API_URL = '/api/users';

class ResetPasswordForm extends Component {
    state = {
        email: {
            value: '',
            isValid: true,
            message: null
        },
    };
    formSubmit = (event) => {
        event.preventDefault();

        const data = {
            email: this.state.email.value
        };

        this.setState({
            email: {
                value: '',
                isValid: true,
                message: null
            }
        });

        axios.post(`${API_URL}/resetPassword`, data)
            .then((response) => {
                NotificationManager.success('', 'Check your email for a link to reset your password.', 10000, () => {
                    this.props.history.push('/');
                });
            })
            .catch((error) => {
                if (error.response.status === 400) {
                    this.setState({
                        email: {
                            value: data.email,
                            isValid: false,
                            message: ' Can\'t find that email, sorry. '
                        }
                    });
                } else {
                    console.log(error);
                }
            });

    };
    inputChangeHandler = event => {
        const value = event.target.value;
        this.setState({
            email: {
                value: value,
                isValid: true,
                message: null
            }
        })
    };

    constructor(props) {
        super(props);
        document.title = 'Reset password';
    }

    render() {
        const bgStyle = {
            backgroundImage: "url('../assets/img/wallpaper-tumblr-pc-awesome-yukle-1200x851-travel-background-tumblr-pc-most-beautiful-of-wallpaper-tumblr-pc.jpg')",
            marginTop: "-20px",
            backgroundSize: "cover",
            backgroundPosition: "top center"
        };

        return (
            <div className="page-header header-filter"
                 style={bgStyle}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 ml-auto mr-auto">
                            <div className="card card-login">
                                <form className="form" onSubmit={this.formSubmit}>
                                    <h3 className="card-title">Reset password <br/>
                                        <small>Enter your email address and we will send you a link to reset your
                                            password.
                                        </small>
                                    </h3>
                                    <br/>
                                    <div className="card-body">
                                        <div className="form-group bmd-form-group ">
                                            <label className="bmd-label-static">Email address</label>
                                            <input
                                                required
                                                className="form-control"
                                                type="text"
                                                name="email"
                                                value={this.state.email.value}
                                                onChange={this.inputChangeHandler}
                                            />
                                            <small
                                                className="form-text text-danger">{this.state.email.message}</small>
                                        </div>
                                    </div>
                                    <br/>
                                    <button type="submit" className="btn btn-primary">Send password reset email</button>
                                </form>

                            </div>
                        </div>
                        <NotificationContainer/>
                    </div>
                </div>
            </div>
        )
    }

}

export default ResetPasswordForm;


// WEBPACK FOOTER //
// ./src/containers/ResetPasswordForm/ResetPasswordForm.jsx